import {ValidationResultEnum} from "../../../../types/validation-result.enum";
import {BookingFlowStepBase} from "../common/booking-flow-step.base";
import {waitForBookingMutations} from "../../models/mutation-actions/wait-for-booking-mutations";
import {DialogCloseButtonBehavior} from "../../../dialog/dialog-enums";
import {PaymentSuccessfulDialog} from "../../../../pages/booking-flow/payment/payment-successful.dialog";
import React from "react";

export class BookingFlowPassengerDetailsStep extends BookingFlowStepBase  {

    get title(): string {
        return this.services.language.translate('Passengers');
    }

    get route() {
        return this.routes.passengersDetails;
    }

    async validate(): Promise<ValidationResultEnum> {
        return await this.booking.passengers.savePassengersDetails();
    }

    async next(): Promise<void> {

        await waitForBookingMutations(this.booking);

        if(ValidationResultEnum.Success !== await this.validate()) {
            return;
        }

        // this should have been done on onBlur, but has no logic to have it there as the validation is made at the end
        this.services.analytics.passengerDetailsEvents.logContactPresent(this.booking);
        this.services.analytics.passengerDetailsEvents.logBeginCheckout(this.booking);

        if(this.booking.passengers.countDogs() > 0) {
            await waitForBookingMutations(this.booking);

            await this.services.loadingIndicator.execute({
                action: async () => {
                    await this.booking.commitBookingAndUpdateBookingState({
                        notifyContacts: false
                    });
                }
            });


            this.services.dialog.showPopupDialog({
                shouldBeClosedOnlyByUser: true,
                maxHeight: "450px",
                width: '416px',
                closeButtonBehavior: DialogCloseButtonBehavior.None,
                render: dialogHandler => {
                    return (<PaymentSuccessfulDialog dialogHandler={dialogHandler}
                                                     customMessage={this.services.language.translationFor("Your booking with code {PNR} was registered.<br/>Soon you will be contacted by our staff to establish your booking details.")
                                                         .withParams({
                                                             PNR: this.booking.recordLocator ?? ""
                                                         })}
                                                     showOnlyCustomMessage={true}/>);
                }
            }).then(() => {
                this.services.navigator.goHome({
                    skipRoutingGuards: true
                });
            });


            return;
        }

        this.booking.tryChangePassengersTypes();

        await waitForBookingMutations(this.booking);

        this._activateStepByRoute(this.routes.seats);


    }
}
